import { catchError } from 'rxjs/operators';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CertService } from '../../services/cert.service';
import { DetailEdictResponse } from '../../models/detail-edict-response.model';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-cert-detail',
  templateUrl: './cert-detail.component.html',
  styleUrls: ['./cert-detail.component.scss']
})
export class CertDetailComponent implements OnInit {
  sendForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    selectedDate: []
  });
  detailResponse: DetailEdictResponse;
  @ViewChild('embedpdf') embedpdf: ElementRef;
  downloadingPDF = false;
  showCertPDFIframe = false;
  certEmailSent = false;
  sendingEmail = false;

  constructor(private fb: FormBuilder,
     private route: ActivatedRoute,
     private certService: CertService) { }

  ngOnInit() {
    this.route.params.subscribe(p => {
      this.getDetail(p['id']);
    });
  }

  getDetail(id: string) {
    this.certService.getDetail(id).subscribe(v => this.detailResponse = v);
  }

  downloadCert(id: string, publishDate: Date) {
    this.downloadingPDF = true;

    this.certService.downloadCert(id, publishDate)
    .subscribe(res => {
      if (res.size) {
        const url = window.URL.createObjectURL(res);
        this.embedpdf.nativeElement.src = url;

        this.embedpdf.nativeElement.style.height = '800px';

        this.showCertPDFIframe = true;

        const pdfSectionPosition = this.embedpdf.nativeElement.getBoundingClientRect().top;

        window.setTimeout(function () {
          window.scrollTo({
            top: pdfSectionPosition,
            behavior: 'smooth'
          });
        }, 150);
      } else if (res.error instanceof Blob) {
        this.certService.downloadCertError(res);
      }
      this.downloadingPDF = false;
    });
  }

  sendEmailCert(id: string, email: string, publishDate: Date) {
    this.sendingEmail = true;
    this.certService.sendEmailCert(id, email, publishDate)
    .subscribe(res => {
      if (res.success === false) {
        this.certService.sendEmailCertError(res.errorMessage);
      } else if (res.success === true) {
        this.certEmailSent = true;
      }
      this.sendingEmail = false;
    });
  }
}
